"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exportMembershipStatusLabels = exports.exportYesNoLabels = exports.getExportDonorReportColumnLabels = exports.exportReceiptColumnLabels = exports.exportBalanceTransactionColumnLabels = exports.exportProductBidsColumnLabels = exports.exportPayoutColumnLabels = exports.exportFundraiserColumnLabels = exports.getExportSupportColumnLabels = exports.getExportMemberColumnLabels = exports.exportOldPaymentLastColumnLabels = exports.getExportOldPaymentColumnLabels = exports.formatExportHonoureeName = exports.getExportTributeLabel = exports.exportTributeLabels = exports.exportGuestListGuestQuestionPrefixLabels = exports.exportGuestListBuyerQuestionPrefixLabels = exports.getExportGuestListLastColumnLabels = exports.exportGuestListColumnLabels = exports.exportGuestListStatusLabels = exports.exportLedgerTransactionTypeLabels = exports.exportLedgerTransactionStatusLabels = exports.getExportTreasuryLedgerTransactionColumnLabels = exports.getExportCampaignBreakdownColumnLabels = exports.getExportFundBreakdownColumnLabels = exports.exportTransactionTypeLabels = exports.exportTransactionCategoryTypeLabels = exports.getExportTransactionColumnLabels = exports.exportPaymentMethodLabels = exports.exportCommandSubscriptionPaymentStatusLabels = exports.exportCommandPaymentStatusLabels = exports.exportDashboardPaymentStatusLabels = void 0;
const common_1 = require("../../enums/common");
const payment_1 = require("../../enums/payment");
const product_donation_1 = require("../../enums/product-donation");
const dates_1 = require("../../helpers/dates");
const locales_1 = require("../enums/locales");
const daf_1 = require("../features/daf");
const export_1 = require("../features/export");
exports.exportDashboardPaymentStatusLabels = {
    [locales_1.Locales.FR]: {
        [common_1.DashboardPaymentStatus.Failed]: "Echoué",
        [common_1.DashboardPaymentStatus.ToConfirm]: "Incomplet",
        [common_1.DashboardPaymentStatus.Due]: "En cours",
        [common_1.DashboardPaymentStatus.Processing]: "En cours",
        [common_1.DashboardPaymentStatus.Succeeded]: "Réussi",
        [common_1.DashboardPaymentStatus.Disputed]: "Disputé",
        [common_1.DashboardPaymentStatus.DisputeLost]: "Dispute perdue",
        [common_1.DashboardPaymentStatus.Weekly]: "Hebdomadaire",
        [common_1.DashboardPaymentStatus.BiWeekly]: "Aux deux semaines",
        [common_1.DashboardPaymentStatus.Monthly]: "Mensuel",
        [common_1.DashboardPaymentStatus.Quarterly]: "Trimestriel",
        [common_1.DashboardPaymentStatus.Yearly]: "Annuel",
        [common_1.DashboardPaymentStatus.Stopped]: "Terminé",
        [common_1.DashboardPaymentStatus.PastDue]: "Paiement en retard",
        [common_1.DashboardPaymentStatus.Unprocessed]: "Non traité",
        [common_1.DashboardPaymentStatus.Incomplete]: "Incomplet",
        [common_1.DashboardPaymentStatus.OnHold]: "En attente",
    },
    [locales_1.Locales.EN]: {
        [common_1.DashboardPaymentStatus.Failed]: "Failed",
        [common_1.DashboardPaymentStatus.ToConfirm]: "Incomplete",
        [common_1.DashboardPaymentStatus.Due]: "Processing",
        [common_1.DashboardPaymentStatus.Processing]: "Processing",
        [common_1.DashboardPaymentStatus.Succeeded]: "Succeeded",
        [common_1.DashboardPaymentStatus.Disputed]: "Disputed",
        [common_1.DashboardPaymentStatus.DisputeLost]: "Dispute lost",
        [common_1.DashboardPaymentStatus.Weekly]: "Weekly",
        [common_1.DashboardPaymentStatus.BiWeekly]: "Bi-weekly",
        [common_1.DashboardPaymentStatus.Monthly]: "Monthly",
        [common_1.DashboardPaymentStatus.Quarterly]: "Quarterly",
        [common_1.DashboardPaymentStatus.Yearly]: "Yearly",
        [common_1.DashboardPaymentStatus.Stopped]: "Stopped",
        [common_1.DashboardPaymentStatus.PastDue]: "Past due",
        [common_1.DashboardPaymentStatus.Unprocessed]: "Unprocessed",
        [common_1.DashboardPaymentStatus.Incomplete]: "Incomplete",
        [common_1.DashboardPaymentStatus.OnHold]: "On hold",
    },
    [locales_1.Locales.ES]: {
        [common_1.DashboardPaymentStatus.Failed]: "Fallido",
        [common_1.DashboardPaymentStatus.ToConfirm]: "Incompleto",
        [common_1.DashboardPaymentStatus.Due]: "Procesando",
        [common_1.DashboardPaymentStatus.Processing]: "Procesando",
        [common_1.DashboardPaymentStatus.Succeeded]: "Exitoso",
        [common_1.DashboardPaymentStatus.Disputed]: "Disputado",
        [common_1.DashboardPaymentStatus.DisputeLost]: "Disputa perdida",
        [common_1.DashboardPaymentStatus.Weekly]: "Semanal",
        [common_1.DashboardPaymentStatus.BiWeekly]: "Quincenal",
        [common_1.DashboardPaymentStatus.Monthly]: "Mensual",
        [common_1.DashboardPaymentStatus.Quarterly]: "Trimestral",
        [common_1.DashboardPaymentStatus.Yearly]: "Anual",
        [common_1.DashboardPaymentStatus.Stopped]: "Detenido",
        [common_1.DashboardPaymentStatus.PastDue]: "Vencido",
        [common_1.DashboardPaymentStatus.Unprocessed]: "Sin procesar",
        [common_1.DashboardPaymentStatus.Incomplete]: "Incompleto",
        [common_1.DashboardPaymentStatus.OnHold]: "En espera",
    },
    [locales_1.Locales.DE]: {
        [common_1.DashboardPaymentStatus.Failed]: "Fehlgeschlagen",
        [common_1.DashboardPaymentStatus.ToConfirm]: "Unvollständig",
        [common_1.DashboardPaymentStatus.Due]: "In Bearbeitung",
        [common_1.DashboardPaymentStatus.Processing]: "In Bearbeitung",
        [common_1.DashboardPaymentStatus.Succeeded]: "Erfolgreich",
        [common_1.DashboardPaymentStatus.Disputed]: "Angefochten",
        [common_1.DashboardPaymentStatus.DisputeLost]: "Anfechtung verloren",
        [common_1.DashboardPaymentStatus.Weekly]: "Wöchentlich",
        [common_1.DashboardPaymentStatus.BiWeekly]: "Zweiwöchentlich",
        [common_1.DashboardPaymentStatus.Monthly]: "Monatlich",
        [common_1.DashboardPaymentStatus.Quarterly]: "Vierteljährlich",
        [common_1.DashboardPaymentStatus.Yearly]: "Jährlich",
        [common_1.DashboardPaymentStatus.Stopped]: "Gestoppt",
        [common_1.DashboardPaymentStatus.PastDue]: "Überfällig",
        [common_1.DashboardPaymentStatus.Unprocessed]: "Nicht verarbeitet",
        [common_1.DashboardPaymentStatus.Incomplete]: "Unvollständig",
        [common_1.DashboardPaymentStatus.OnHold]: "Zurückgestellt",
    },
};
exports.exportCommandPaymentStatusLabels = {
    [locales_1.Locales.FR]: {
        failed: "Echoué",
        toConfirm: "Incomplet",
        due: "En cours",
        processing: "En cours",
        succeeded: "Réussi",
        incomplete: "Incomplet",
        onHold: "En attente",
        unprocessed: "Non traité",
        refunded: "Remboursé",
    },
    [locales_1.Locales.EN]: {
        failed: "Failed",
        toConfirm: "Incomplete",
        due: "Processing",
        processing: "Processing",
        succeeded: "Succeeded",
        incomplete: "Incomplete",
        onHold: "On hold",
        unprocessed: "Unprocessed",
        refunded: "Refunded",
    },
    [locales_1.Locales.ES]: {
        failed: "Fallido",
        toConfirm: "Incompleto",
        due: "Procesando",
        processing: "Procesando",
        succeeded: "Exitoso",
        incomplete: "Incompleto",
        onHold: "En espera",
        unprocessed: "Sin procesar",
        refunded: "Reembolsado",
    },
    [locales_1.Locales.DE]: {
        failed: "Fehlgeschlagen",
        toConfirm: "Unvollständig",
        due: "In Bearbeitung",
        processing: "In Bearbeitung",
        succeeded: "Erfolgreich",
        incomplete: "Unvollständig",
        onHold: "Zurückgestellt",
        unprocessed: "Nicht verarbeitet",
        refunded: "Erstattet",
    },
};
exports.exportCommandSubscriptionPaymentStatusLabels = {
    [locales_1.Locales.FR]: {
        pastDue: "En retard",
        stopped: "Terminé",
        ended: "Arrivé à terme",
        expired: "Expiré",
        weekly: "Hebdomadaire",
        biWeekly: "Aux deux semaines",
        monthly: "Mensuel",
        quarterly: "Trimestriel",
        yearly: "Annuel",
    },
    [locales_1.Locales.EN]: {
        pastDue: "Past due",
        stopped: "Stopped",
        ended: "Ended",
        expired: "Expired",
        weekly: "Weekly",
        biWeekly: "Bi-weekly",
        monthly: "Monthly",
        quarterly: "Quarterly",
        yearly: "Yearly",
    },
    [locales_1.Locales.ES]: {
        pastDue: "Vencido",
        stopped: "Detenido",
        ended: "Finalizado",
        expired: "Expirado",
        weekly: "Semanal",
        biWeekly: "Quincenal",
        monthly: "Mensual",
        quarterly: "Trimestral",
        yearly: "Anual",
    },
    [locales_1.Locales.DE]: {
        pastDue: "Überfällig",
        stopped: "Gestoppt",
        ended: "Beendet",
        expired: "Abgelaufen",
        weekly: "Wöchentlich",
        biWeekly: "Zweiwöchentlich",
        monthly: "Monatlich",
        quarterly: "Vierteljährlich",
        yearly: "Jährlich",
    },
};
exports.exportPaymentMethodLabels = {
    [locales_1.Locales.FR]: {
        [payment_1.PaymentMethod.Card]: "Carte",
        [payment_1.PaymentMethod.Transfer]: "Virement",
        [payment_1.PaymentMethod.Cheque]: "Chèque",
        [payment_1.PaymentMethod.Daf]: "DAF",
        [payment_1.PaymentMethod.Unknown]: "Inconnue",
        [payment_1.PaymentMethod.Free]: "Gratuit",
        [payment_1.PaymentMethod.Manual]: "Manuel",
        [payment_1.PaymentMethod.Pad]: "Débit préautorisé",
        [payment_1.PaymentMethod.Ach]: "Débit direct ACH",
        [payment_1.PaymentMethod.Sepa]: "Prélèvement SEPA",
        [payment_1.PaymentMethod.ApplePayOrGooglePay]: "Apple Pay / Google Pay",
        [payment_1.PaymentMethod.Cash]: "Espèce",
        [payment_1.PaymentMethod.InKind]: "En nature",
        [payment_1.PaymentMethod.Stocks]: "Actions",
        [payment_1.PaymentMethod.Other]: "Autre",
        [payment_1.PaymentMethod.TapToPay]: "Tap-to-pay",
        [payment_1.PaymentMethod.CashApp]: "Cash App",
        [payment_1.PaymentMethod.PayPal]: "PayPal",
        [payment_1.PaymentMethod.Venmo]: "Venmo",
        [payment_1.PaymentMethod.Pledge]: "Promesse",
        [payment_1.PaymentMethod.Invoice]: "Facture",
        [payment_1.PaymentMethod.InPersonCash]: "Comptant (en personne)",
    },
    [locales_1.Locales.EN]: {
        [payment_1.PaymentMethod.Card]: "Card",
        [payment_1.PaymentMethod.Transfer]: "Transfer",
        [payment_1.PaymentMethod.Cheque]: "Cheque",
        [payment_1.PaymentMethod.Daf]: "DAF",
        [payment_1.PaymentMethod.Unknown]: "Unknown",
        [payment_1.PaymentMethod.Free]: "Free",
        [payment_1.PaymentMethod.Manual]: "Manual",
        [payment_1.PaymentMethod.Pad]: "Pre-authorized debit",
        [payment_1.PaymentMethod.Ach]: "ACH Direct debit",
        [payment_1.PaymentMethod.Sepa]: "SEPA Direct Debit",
        [payment_1.PaymentMethod.ApplePayOrGooglePay]: "Apple Pay / Google Pay",
        [payment_1.PaymentMethod.Cash]: "Cash",
        [payment_1.PaymentMethod.InKind]: "In kind",
        [payment_1.PaymentMethod.Stocks]: "Stocks",
        [payment_1.PaymentMethod.Other]: "Other",
        [payment_1.PaymentMethod.TapToPay]: "Tap-to-pay",
        [payment_1.PaymentMethod.CashApp]: "Cash App",
        [payment_1.PaymentMethod.PayPal]: "PayPal",
        [payment_1.PaymentMethod.Venmo]: "Venmo",
        [payment_1.PaymentMethod.Pledge]: "Pledge",
        [payment_1.PaymentMethod.Invoice]: "Invoice",
        [payment_1.PaymentMethod.InPersonCash]: "Cash (in-person)",
    },
    [locales_1.Locales.ES]: {
        [payment_1.PaymentMethod.Card]: "Tarjeta",
        [payment_1.PaymentMethod.Transfer]: "Transferencia",
        [payment_1.PaymentMethod.Cheque]: "Cheque",
        [payment_1.PaymentMethod.Daf]: "DAF",
        [payment_1.PaymentMethod.Unknown]: "Desconocido",
        [payment_1.PaymentMethod.Free]: "Gratis",
        [payment_1.PaymentMethod.Manual]: "Manual",
        [payment_1.PaymentMethod.Pad]: "Débito preautorizado",
        [payment_1.PaymentMethod.Ach]: "Débito directo ACH",
        [payment_1.PaymentMethod.Sepa]: "Débito directo SEPA",
        [payment_1.PaymentMethod.ApplePayOrGooglePay]: "Apple Pay / Google Pay",
        [payment_1.PaymentMethod.Cash]: "Efectivo",
        [payment_1.PaymentMethod.InKind]: "En especie",
        [payment_1.PaymentMethod.Stocks]: "Acciones",
        [payment_1.PaymentMethod.Other]: "Otro",
        [payment_1.PaymentMethod.TapToPay]: "Toque para pagar",
        [payment_1.PaymentMethod.CashApp]: "Cash App",
        [payment_1.PaymentMethod.PayPal]: "PayPal",
        [payment_1.PaymentMethod.Venmo]: "Venmo",
        [payment_1.PaymentMethod.Pledge]: "Promesa",
        [payment_1.PaymentMethod.Invoice]: "Factura",
        [payment_1.PaymentMethod.InPersonCash]: "Efectivo (en persona)",
    },
    [locales_1.Locales.DE]: {
        [payment_1.PaymentMethod.Card]: "Karte",
        [payment_1.PaymentMethod.Transfer]: "Überweisung",
        [payment_1.PaymentMethod.Cheque]: "Scheck",
        [payment_1.PaymentMethod.Daf]: "DAF",
        [payment_1.PaymentMethod.Unknown]: "Unbekannt",
        [payment_1.PaymentMethod.Free]: "Kostenlos",
        [payment_1.PaymentMethod.Manual]: "Manuell",
        [payment_1.PaymentMethod.Pad]: "Vorautorisierter Bankeinzug",
        [payment_1.PaymentMethod.Ach]: "ACH-Lastschrift",
        [payment_1.PaymentMethod.Sepa]: "SEPA-Lastschrift",
        [payment_1.PaymentMethod.ApplePayOrGooglePay]: "Apple Pay / Google Pay",
        [payment_1.PaymentMethod.Cash]: "Bargeld",
        [payment_1.PaymentMethod.InKind]: "Sachspende",
        [payment_1.PaymentMethod.Stocks]: "Aktien",
        [payment_1.PaymentMethod.Other]: "Sonstiges",
        [payment_1.PaymentMethod.TapToPay]: "Tap-to-pay",
        [payment_1.PaymentMethod.CashApp]: "Cash App",
        [payment_1.PaymentMethod.PayPal]: "PayPal",
        [payment_1.PaymentMethod.Venmo]: "Venmo",
        [payment_1.PaymentMethod.Pledge]: "Zusage",
        [payment_1.PaymentMethod.Invoice]: "Rechnung",
        [payment_1.PaymentMethod.InPersonCash]: "Bargeld (persönlich)",
    },
};
const getExportTransactionColumnLabels = (timezone) => ({
    [locales_1.Locales.FR]: {
        id: "Id",
        amount: "Montant",
        type: "Type",
        category: "Catégorie",
        firstName: "Prénom",
        lastName: "Nom",
        email: "Courriel",
        createdAt: `Date de création (${timezone})`,
        availableOn: `Disponible le (${timezone})`,
        eligibleAmount: `Montant éligible`,
        formName: "Campagne",
        fundName: "Fonds",
        description: "Description",
    },
    [locales_1.Locales.EN]: {
        id: "Id",
        amount: "Amount",
        type: "Type",
        category: "Category",
        firstName: "First Name",
        lastName: "Last Name",
        email: "Email",
        createdAt: `Creation Date (${timezone})`,
        availableOn: `Available on (${timezone})`,
        eligibleAmount: "Eligible amount",
        formName: "Campaign",
        fundName: "Fund",
        description: "Description",
    },
    [locales_1.Locales.ES]: {
        id: "Id",
        amount: "Amount",
        type: "Type",
        category: "Category",
        firstName: "First Name",
        lastName: "Last Name",
        email: "Email",
        createdAt: `Creation Date (${timezone})`,
        availableOn: `Available on (${timezone})`,
        eligibleAmount: "Eligible amount",
        formName: "Campaign",
        fundName: "Fund",
        description: "Description",
    },
    [locales_1.Locales.DE]: {
        id: "Id",
        amount: "Betrag",
        type: "Typ",
        category: "Kategorie",
        firstName: "Vorname",
        lastName: "Nachname",
        email: "E-Mail",
        createdAt: `Erstellungsdatum (${timezone})`,
        availableOn: `Verfügbar am (${timezone})`,
        eligibleAmount: "Abzugsfähiger Betrag",
        formName: "Kampagne",
        fundName: "Fonds",
        description: "Beschreibung",
    },
});
exports.getExportTransactionColumnLabels = getExportTransactionColumnLabels;
exports.exportTransactionCategoryTypeLabels = {
    [locales_1.Locales.FR]: {
        event: "Événement",
        membership: "Adhésion",
        shop: "Boutique en ligne",
        raffle: "Tirage au sort",
        auction: "Encan",
        custom: "Formulaire personnalisé",
        donation: "Don",
        disputePending: "Litige en cours",
        disputeReversal: "Annulation de litige",
    },
    [locales_1.Locales.EN]: {
        event: "Event",
        membership: "Membership",
        shop: "Shop",
        raffle: "Raffle",
        auction: "Auction",
        custom: "Custom form",
        donation: "Donation",
        disputePending: "Dispute pending",
        disputeReversal: "Dispute reversal",
    },
    [locales_1.Locales.ES]: {
        event: "Evento",
        membership: "Membresía",
        shop: "Tienda",
        raffle: "Rifa",
        auction: "Subasta",
        custom: "Formulario personalizado",
        donation: "Don",
        disputePending: "Disputa pendiente",
        disputeReversal: "Reversión de disputa",
    },
    [locales_1.Locales.DE]: {
        event: "Veranstaltung",
        membership: "Mitgliedschaft",
        shop: "Shop",
        raffle: "Verlosung",
        auction: "Auktion",
        custom: "Benutzerdefiniertes Formular",
        donation: "Spende",
        disputePending: "Anfechtung ausstehend",
        disputeReversal: "Anfechtungsrückbuchung",
    },
};
exports.exportTransactionTypeLabels = {
    [locales_1.Locales.FR]: { payment: "Paiement", refund: "Remboursement", dispute: "Litige", other: "Autre" },
    [locales_1.Locales.EN]: { payment: "Payment", refund: "Refund", dispute: "Dispute", other: "Other" },
    [locales_1.Locales.ES]: { payment: "Pago", refund: "Reembolso", dispute: "Disputa", other: "Otro" },
    [locales_1.Locales.DE]: { payment: "Zahlung", refund: "Rückerstattung", dispute: "Anfechtung", other: "Sonstiges" },
};
const getExportFundBreakdownColumnLabels = (timezone) => ({
    [locales_1.Locales.FR]: {
        fundName: "Fonds",
        fundCode: "Code du fonds",
        totalAmount: "Montant total",
        payoutDate: `Date du paiement (${timezone})`,
    },
    [locales_1.Locales.EN]: {
        fundName: "Fund name",
        fundCode: "Fund code",
        totalAmount: "Fund amount",
        payoutDate: `Payout date (${timezone})`,
    },
    [locales_1.Locales.ES]: {
        fundName: "Fondo",
        fundCode: "Código del fondo",
        totalAmount: "Importe total",
        payoutDate: `Fecha de pago (${timezone})`,
    },
    [locales_1.Locales.DE]: {
        fundName: "Fondsname",
        fundCode: "Fondscode",
        totalAmount: "Fondsbetrag",
        payoutDate: `Auszahlungsdatum (${timezone})`,
    },
});
exports.getExportFundBreakdownColumnLabels = getExportFundBreakdownColumnLabels;
const getExportCampaignBreakdownColumnLabels = (timezone) => ({
    [locales_1.Locales.FR]: {
        campaignName: "Campagne",
        totalAmount: "Montant total",
        payoutDate: `Date du paiement (${timezone})`,
    },
    [locales_1.Locales.EN]: {
        campaignName: "Campaign",
        totalAmount: "Campaign amount",
        payoutDate: `Payout date (${timezone})`,
    },
    [locales_1.Locales.ES]: {
        campaignName: "Campaña",
        totalAmount: "Importe total",
        payoutDate: `Fecha de pago (${timezone})`,
    },
    [locales_1.Locales.DE]: {
        campaignName: "Kampagne",
        totalAmount: "Kampagnenbetrag",
        payoutDate: `Auszahlungsdatum (${timezone})`,
    },
});
exports.getExportCampaignBreakdownColumnLabels = getExportCampaignBreakdownColumnLabels;
const getExportTreasuryLedgerTransactionColumnLabels = () => ({
    [locales_1.Locales.FR]: {
        date: "Date",
        amount: "Montant",
        details: "Détails",
        status: "Statut",
        type: "Type",
        category: "Catégorie",
        subcategory: "Sous-catégorie",
        firstName: "Prénom",
        lastName: "Nom",
        email: "Courriel",
        formName: "Campagne",
    },
    [locales_1.Locales.EN]: {
        date: "Date",
        amount: "Amount",
        details: "Details",
        status: "Status",
        type: "Type",
        category: "Category",
        subcategory: "Subcategory",
        firstName: "First Name",
        lastName: "Last Name",
        email: "Email",
        formName: "Campaign",
    },
    [locales_1.Locales.ES]: {
        date: "Fecha",
        amount: "Cantidad",
        details: "Detalles",
        status: "Estado",
        type: "Tipo",
        category: "Categoría",
        subcategory: "Subcategoría",
        firstName: "First Name",
        lastName: "Last Name",
        email: "Email",
        formName: "Campaign",
    },
    [locales_1.Locales.DE]: {
        date: "Datum",
        amount: "Betrag",
        details: "Details",
        status: "Status",
        type: "Typ",
        category: "Kategorie",
        subcategory: "Unterkategorie",
        firstName: "Vorname",
        lastName: "Nachname",
        email: "E-Mail",
        formName: "Kampagne",
    },
});
exports.getExportTreasuryLedgerTransactionColumnLabels = getExportTreasuryLedgerTransactionColumnLabels;
exports.exportLedgerTransactionStatusLabels = {
    [locales_1.Locales.FR]: {
        succeeded: "Réussie",
    },
    [locales_1.Locales.EN]: {
        succeeded: "Succeeded",
    },
    [locales_1.Locales.ES]: {
        succeeded: "Exitoso",
    },
    [locales_1.Locales.DE]: {
        succeeded: "Erfolgreich",
    },
};
exports.exportLedgerTransactionTypeLabels = {
    [locales_1.Locales.FR]: {
        fundraising_dispute: "Litige de collecte",
        fundraising_dispute_win: "Gain de litige de collecte",
        fundraising_payment: "Collecte de fonds",
        fundraising_refund: "Remboursement de collecte",
        issuing_dispute: "Litige de dépense",
        issuing_payment: "Dépense",
        issuing_refund: "Remboursement de dépense",
        issuing_reward: "Récompense",
        referral_payment: "Parrainage",
        treasury_interest: "Intérêts",
        treasury_outbound_payment: "Virement",
        treasury_received_credit: "Crédit",
        treasury_received_debit: "Débit",
    },
    [locales_1.Locales.EN]: {
        fundraising_dispute: "Fundraising Dispute",
        fundraising_dispute_win: "Fundraising Dispute Win",
        fundraising_payment: "Fundraising",
        fundraising_refund: "Fundraising Refund",
        issuing_dispute: "Expense Dispute",
        issuing_payment: "Expense",
        issuing_refund: "Expense Refund",
        issuing_reward: "Reward",
        referral_payment: "Referral",
        treasury_interest: "Yield",
        treasury_outbound_payment: "Transfer",
        treasury_received_credit: "Credit",
        treasury_received_debit: "Debit",
    },
    [locales_1.Locales.ES]: {
        fundraising_dispute: "Disputa de recaudación",
        fundraising_dispute_win: "Ganancia de disputa de recaudación",
        fundraising_payment: "Recaudación de fondos",
        fundraising_refund: "Reembolso de recaudación",
        issuing_dispute: "Disputa de gasto",
        issuing_payment: "Gasto",
        issuing_refund: "Reembolso de gasto",
        issuing_reward: "Recompensa",
        referral_payment: "Referencia",
        treasury_interest: "Rendimiento",
        treasury_outbound_payment: "Transferencia",
        treasury_received_credit: "Crédito",
        treasury_received_debit: "Débito",
    },
    [locales_1.Locales.DE]: {
        fundraising_dispute: "Fundraising-Anfechtung",
        fundraising_dispute_win: "Gewonnene Fundraising-Anfechtung",
        fundraising_payment: "Fundraising",
        fundraising_refund: "Fundraising-Erstattung",
        issuing_dispute: "Ausgabenanfechtung",
        issuing_payment: "Ausgabe",
        issuing_refund: "Ausgabenerstattung",
        issuing_reward: "Belohnung",
        referral_payment: "Empfehlung",
        treasury_interest: "Rendite",
        treasury_outbound_payment: "Überweisung",
        treasury_received_credit: "Gutschrift",
        treasury_received_debit: "Lastschrift",
    },
};
exports.exportGuestListStatusLabels = {
    [locales_1.Locales.FR]: {},
    [locales_1.Locales.EN]: {},
    [locales_1.Locales.ES]: {},
    [locales_1.Locales.DE]: {},
};
exports.exportGuestListColumnLabels = {
    [locales_1.Locales.FR]: {
        buyerFirstName: "Prénom de l'acheteur",
        buyerLastName: "Nom de l'acheteur",
        buyerEmail: "Courriel de l'acheteur",
        guestFirstName: "Prénom de l'invité",
        guestLastName: "Nom de l'invité",
        guestName: "Nom de l'invité",
        guestEmail: "Courriel de l'invité",
        numberOfTickets: "Nombre de billets",
        ticketCount: "Decompte des billets",
        ticketType: "Type de billet",
    },
    [locales_1.Locales.EN]: {
        buyerFirstName: "Buyer first name",
        buyerLastName: "Buyer last name",
        buyerEmail: "Buyer email",
        guestFirstName: "Guest first name",
        guestLastName: "Guest last name",
        guestName: "Guest name",
        guestEmail: "Guest email",
        numberOfTickets: "Number of tickets",
        ticketCount: "Ticket count",
        ticketType: "Ticket type",
    },
    [locales_1.Locales.ES]: {
        buyerFirstName: "Nombre del comprador",
        buyerLastName: "Apellido del comprador",
        buyerEmail: "Correo electrónico del comprador",
        guestFirstName: "Nombre del invitado",
        guestLastName: "Apellido del invitado",
        guestName: "Nombre del invitado",
        guestEmail: "Correo electrónico del invitado",
        numberOfTickets: "Número de boletos",
        ticketCount: "Conteo de boletos",
        ticketType: "Tipo de boleto",
    },
    [locales_1.Locales.DE]: {
        buyerFirstName: "Vorname der Käuferin/des Käufers",
        buyerLastName: "Nachname der Käuferin/des Käufers",
        buyerEmail: "E-Mail der Käuferin/des Käufers",
        guestFirstName: "Vorname des Gastes",
        guestLastName: "Nachname des Gastes",
        guestName: "Name des Gastes",
        guestEmail: "E-Mail des Gastes",
        numberOfTickets: "Anzahl der Tickets",
        ticketCount: "Ticketanzahl",
        ticketType: "Tickettyp",
    },
};
const getExportGuestListLastColumnLabels = (timezone) => ({
    [locales_1.Locales.FR]: {
        ticketAnnotation: "Annotation du billet",
        ticketStatus: `Status ${(0, dates_1.formatDateToShortDateTime)(new Date(), locales_1.Locales.FR, timezone)}`,
    },
    [locales_1.Locales.EN]: {
        ticketAnnotation: "Ticket note",
        ticketStatus: `Status ${(0, dates_1.formatDateToShortDateTime)(new Date(), locales_1.Locales.EN, timezone)}`,
    },
    [locales_1.Locales.ES]: {
        ticketAnnotation: "Nota del boleto",
        ticketStatus: `Estado ${(0, dates_1.formatDateToShortDateTime)(new Date(), locales_1.Locales.ES, timezone)}`,
    },
    [locales_1.Locales.DE]: {
        ticketAnnotation: "Ticketnotiz",
        ticketStatus: `Status ${(0, dates_1.formatDateToShortDateTime)(new Date(), locales_1.Locales.DE, timezone)}`,
    },
});
exports.getExportGuestListLastColumnLabels = getExportGuestListLastColumnLabels;
exports.exportGuestListBuyerQuestionPrefixLabels = {
    [locales_1.Locales.FR]: "Question de l'acheteur",
    [locales_1.Locales.EN]: "Buyer question",
    [locales_1.Locales.ES]: "Pregunta del comprador",
    [locales_1.Locales.DE]: "Frage an die Käuferin/den Käufer",
};
exports.exportGuestListGuestQuestionPrefixLabels = {
    [locales_1.Locales.FR]: "Question de l'invité",
    [locales_1.Locales.EN]: "Guest question",
    [locales_1.Locales.ES]: "Pregunta del invitado",
    [locales_1.Locales.DE]: "Frage an den Gast",
};
exports.exportTributeLabels = {
    [locales_1.Locales.FR]: {
        [product_donation_1.Tribute.InHonourOf]: "En l'honneur de",
        [product_donation_1.Tribute.InMemoryOf]: "À la mémoire de",
    },
    [locales_1.Locales.EN]: {
        [product_donation_1.Tribute.InHonourOf]: "In honour of",
        [product_donation_1.Tribute.InMemoryOf]: "In memory of",
    },
    [locales_1.Locales.ES]: {
        [product_donation_1.Tribute.InHonourOf]: "En honor de",
        [product_donation_1.Tribute.InMemoryOf]: "En memoria de",
    },
    [locales_1.Locales.DE]: {
        [product_donation_1.Tribute.InHonourOf]: "Zu Ehren von",
        [product_donation_1.Tribute.InMemoryOf]: "Im Gedenken an",
    },
};
const getExportTributeLabel = (tribute, locale) => tribute ? exports.exportTributeLabels[locale][tribute] : undefined;
exports.getExportTributeLabel = getExportTributeLabel;
const formatExportHonoureeName = (inHonourName, tribute, locale) => {
    const name = inHonourName?.trim();
    if (!name) {
        return undefined;
    }
    const tributeLabel = (0, exports.getExportTributeLabel)(tribute, locale);
    return tributeLabel ? `${tributeLabel} ${name}` : name;
};
exports.formatExportHonoureeName = formatExportHonoureeName;
const getExportDafProviderColumnLabel = (country, label) => ((0, daf_1.countryAllowsDaf)(country) ? { dafProvider: label } : {});
const getExportOldPaymentColumnLabels = (timezone, country) => ({
    [locales_1.Locales.FR]: {
        formName: "Nom du formulaire",
        createdAt: `Date de création (${timezone})`,
        amount: "Montant",
        refundedAmount: "Montant remboursé",
        detail: "Détail",
        lastName: "Nom",
        firstName: "Prénom",
        companyName: "Nom de l'entreprise",
        email: "Courriel",
        address: "Adresse",
        city: "Ville",
        postalCode: (0, export_1.getExportPostalCodeColumnLabel)(locales_1.Locales.FR, country),
        region: (0, export_1.getExportRegionColumnLabel)(locales_1.Locales.FR, country),
        country: "Pays",
        paymentMethod: "Méthode de paiement",
        ...getExportDafProviderColumnLabel(country, "Fournisseur DAF"),
        receiptNumber: "Reçu",
        receiptUrl: "URL du reçu",
        linkToForm: "Lien vers le formulaire",
        locale: "Langue",
        status: "Statut",
        recurringStatus: "Statut récurrent",
        ticketNumber: "Numéro de billet",
        addOnNumber: "Numéro d'extra",
        occurrence: "Occurrence",
        extraDonation: "Don supplémentaire",
        eligibleAmount: "Montant éligible",
        expirationDate: "Date d'expiration",
        canceled: "Annulé",
        ticketAmount: "Montant du billet",
        discount: "Réduction",
        eTicketUrl: "URL du billet électronique",
        scan: "Scans",
        lastScan: "Dernier scan",
        campaignName: "Nom de la campagne",
        teamName: "Nom de l'équipe",
        teamCreationDate: "Date de création de l'équipe",
        note: "Note",
        inHonourName: "En l'honneur ou à la mémoire de",
    },
    [locales_1.Locales.EN]: {
        formName: "Form name",
        createdAt: `Creation date (${timezone})`,
        amount: "Amount",
        refundedAmount: "Refunded amount",
        detail: "Detail",
        lastName: "Last name",
        firstName: "First name",
        companyName: "Company name",
        email: "Email",
        address: "Address",
        city: "City",
        postalCode: (0, export_1.getExportPostalCodeColumnLabel)(locales_1.Locales.EN, country),
        region: (0, export_1.getExportRegionColumnLabel)(locales_1.Locales.EN, country),
        country: "Country",
        paymentMethod: "Payment method",
        ...getExportDafProviderColumnLabel(country, "DAF provider"),
        receiptNumber: "Receipt",
        receiptUrl: "Receipt URL",
        linkToForm: "Link to form",
        locale: "Language",
        status: "Status",
        recurringStatus: "Recurring status",
        ticketNumber: "Ticket number",
        addOnNumber: "Add-on number",
        occurrence: "Occurrence",
        extraDonation: "Extra donation",
        eligibleAmount: "Eligible amount",
        expirationDate: "Expiration date",
        canceled: "Canceled",
        ticketAmount: "Ticket amount",
        discount: "Discount",
        eTicketUrl: "E-ticket URL",
        scan: "Scans",
        lastScan: "Last scan",
        campaignName: "Campaign name",
        teamName: "Team name",
        teamCreationDate: "Team creation date",
        note: "Note",
        inHonourName: "In honour or in memory of",
    },
    [locales_1.Locales.ES]: {
        formName: "Nombre del formulario",
        createdAt: `Fecha de creación (${timezone})`,
        amount: "Importe",
        refundedAmount: "Importe reembolsado",
        detail: "Detalle",
        lastName: "Apellido",
        firstName: "Nombre",
        companyName: "Nombre de la empresa",
        email: "Correo electrónico",
        address: "Dirección",
        city: "Ciudad",
        postalCode: (0, export_1.getExportPostalCodeColumnLabel)(locales_1.Locales.ES, country),
        region: (0, export_1.getExportRegionColumnLabel)(locales_1.Locales.ES, country),
        country: "País",
        paymentMethod: "Forma de pago",
        ...getExportDafProviderColumnLabel(country, "Proveedor DAF"),
        receiptNumber: "Recibo",
        receiptUrl: "URL del recibo",
        linkToForm: "Enlace al formulario",
        locale: "Idioma",
        status: "Estado",
        recurringStatus: "Estado recurrente",
        ticketNumber: "Número de billete",
        addOnNumber: "Número de complemento",
        occurrence: "Ocurrencia",
        extraDonation: "Donación extra",
        eligibleAmount: "Importe éligible",
        expirationDate: "Fecha de caducidad",
        canceled: "Cancelado",
        ticketAmount: "Importe del billete",
        discount: "Descuento",
        eTicketUrl: "URL del billete electrónico",
        scan: "Escaneos",
        lastScan: "Último escaneo",
        campaignName: "Nombre de la campaña",
        teamName: "Nombre del equipo",
        teamCreationDate: "Fecha de creación del equipo",
        note: "Nota",
        inHonourName: "En honor o en memoria de",
    },
    [locales_1.Locales.DE]: {
        formName: "Formularname",
        createdAt: `Erstellungsdatum (${timezone})`,
        amount: "Betrag",
        refundedAmount: "Erstatteter Betrag",
        detail: "Detail",
        lastName: "Nachname",
        firstName: "Vorname",
        companyName: "Unternehmensname",
        email: "E-Mail",
        address: "Adresse",
        city: "Stadt",
        postalCode: (0, export_1.getExportPostalCodeColumnLabel)(locales_1.Locales.DE, country),
        region: (0, export_1.getExportRegionColumnLabel)(locales_1.Locales.DE, country),
        country: "Land",
        paymentMethod: "Zahlungsmethode",
        ...getExportDafProviderColumnLabel(country, "DAF-Anbieter"),
        receiptNumber: "Beleg",
        receiptUrl: "Beleg-URL",
        linkToForm: "Link zum Formular",
        locale: "Sprache",
        status: "Status",
        recurringStatus: "Wiederkehrender Status",
        ticketNumber: "Ticketnummer",
        addOnNumber: "Add-on-Nummer",
        occurrence: "Termin",
        extraDonation: "Zusätzliche Spende",
        eligibleAmount: "Abzugsfähiger Betrag",
        expirationDate: "Ablaufdatum",
        canceled: "Storniert",
        ticketAmount: "Ticketbetrag",
        discount: "Rabatt",
        eTicketUrl: "E-Ticket-URL",
        scan: "Scans",
        lastScan: "Letzter Scan",
        campaignName: "Kampagnenname",
        teamName: "Teamname",
        teamCreationDate: "Erstellungsdatum des Teams",
        note: "Notiz",
        inHonourName: "Zu Ehren oder in Erinnerung an",
    },
});
exports.getExportOldPaymentColumnLabels = getExportOldPaymentColumnLabels;
exports.exportOldPaymentLastColumnLabels = {
    [locales_1.Locales.FR]: {
        payoutDate: "Date de virement",
    },
    [locales_1.Locales.EN]: {
        payoutDate: "Payout date",
    },
    [locales_1.Locales.ES]: {
        payoutDate: "Fecha de pago",
    },
    [locales_1.Locales.DE]: {
        payoutDate: "Auszahlungsdatum",
    },
};
const getExportMemberColumnLabels = (timezone, country) => {
    return {
        [locales_1.Locales.FR]: {
            firstName: "Prenom",
            lastName: "Nom",
            email: "Courriel",
            secondaryEmail: "Courriel secondaire",
            amount: "Montant",
            firstPaymentDate: `Date du premier paiement (${timezone})`,
            lastPaymentDate: `Date du dernier paiement (${timezone})`,
            locale: "Langue",
            address: "Adresse",
            city: "Ville",
            postalCode: (0, export_1.getExportPostalCodeColumnLabel)(locales_1.Locales.FR, country),
            country: "Pays",
            region: (0, export_1.getExportRegionColumnLabel)(locales_1.Locales.FR, country),
            phoneNumber: "Telephone",
            companyName: "Nom de l'entreprise",
            notes: "Notes",
            manualLists: "Listes manuelles",
            unsubscribe: "Désabonné",
            membershipStatus: "Statut d'adhésion",
            membershipType: "Niveau d'adhésion",
            campaignName: "Nom de la campagne",
            joinDate: `Date d'adhésion (${timezone})`,
            expirationDate: `Date d'expiration (${timezone})`,
            autoRenew: "Renouvellement auto",
            memberNumber: "Numero de membre",
        },
        [locales_1.Locales.EN]: {
            firstName: "First name",
            lastName: "Last name",
            email: "Email",
            secondaryEmail: "Secondary email",
            amount: "Amount",
            firstPaymentDate: `First payment date (${timezone})`,
            lastPaymentDate: `Last payment date (${timezone})`,
            locale: "Language",
            address: "Address",
            city: "City",
            postalCode: (0, export_1.getExportPostalCodeColumnLabel)(locales_1.Locales.EN, country),
            country: "Country",
            region: (0, export_1.getExportRegionColumnLabel)(locales_1.Locales.EN, country),
            phoneNumber: "Phone",
            companyName: "Company name",
            notes: "Notes",
            manualLists: "Manual lists",
            unsubscribe: "Unsubscribed",
            membershipStatus: "Membership status",
            membershipType: "Membership tier",
            campaignName: "Campaign name",
            joinDate: `Join date (${timezone})`,
            expirationDate: `Expiration date (${timezone})`,
            autoRenew: "Auto-renew",
            memberNumber: "Member number",
        },
        [locales_1.Locales.ES]: {
            firstName: "Nombre",
            lastName: "Apellido",
            email: "Correo electrónico",
            secondaryEmail: "Correo electrónico secundario",
            amount: "Importe",
            firstPaymentDate: `Fecha del primer pago (${timezone})`,
            lastPaymentDate: `Fecha del último pago (${timezone})`,
            locale: "Idioma",
            address: "Dirección",
            city: "Ciudad",
            postalCode: (0, export_1.getExportPostalCodeColumnLabel)(locales_1.Locales.ES, country),
            country: "País",
            region: (0, export_1.getExportRegionColumnLabel)(locales_1.Locales.ES, country),
            phoneNumber: "Teléfono",
            companyName: "Nombre de la empresa",
            notes: "Notas",
            manualLists: "Listas manuales",
            unsubscribe: "Baja de suscripción",
            membershipStatus: "Estado de la membresía",
            membershipType: "Nivel de membresía",
            campaignName: "Nombre de la campaña",
            joinDate: `Fecha de alta (${timezone})`,
            expirationDate: `Fecha de caducidad (${timezone})`,
            autoRenew: "Renovación automática",
            memberNumber: "Número de miembro",
        },
        [locales_1.Locales.DE]: {
            firstName: "Vorname",
            lastName: "Nachname",
            email: "E-Mail",
            secondaryEmail: "Zweite E-Mail",
            amount: "Betrag",
            firstPaymentDate: `Datum der ersten Zahlung (${timezone})`,
            lastPaymentDate: `Datum der letzten Zahlung (${timezone})`,
            locale: "Sprache",
            address: "Adresse",
            city: "Stadt",
            postalCode: (0, export_1.getExportPostalCodeColumnLabel)(locales_1.Locales.DE, country),
            country: "Land",
            region: (0, export_1.getExportRegionColumnLabel)(locales_1.Locales.DE, country),
            phoneNumber: "Telefon",
            companyName: "Unternehmensname",
            notes: "Notizen",
            manualLists: "Manuelle Listen",
            membershipStatus: "Mitgliedschaftsstatus",
            membershipType: "Mitgliedschaftsstufe",
            campaignName: "Kampagnenname",
            joinDate: `Beitrittsdatum (${timezone})`,
            expirationDate: `Ablaufdatum (${timezone})`,
            autoRenew: "Automatische Verlängerung",
            memberNumber: "Mitgliedsnummer",
        },
    };
};
exports.getExportMemberColumnLabels = getExportMemberColumnLabels;
const getExportSupportColumnLabels = (timezone, country) => {
    return {
        [locales_1.Locales.FR]: {
            firstName: "Prénom",
            lastName: "Nom",
            email: "Courriel",
            secondaryEmail: "Courriel secondaire",
            amount: "Montant",
            firstPaymentDate: `Date du premier paiement (${timezone})`,
            lastPaymentDate: `Date du dernier paiement (${timezone})`,
            locale: "Langue",
            address: "Adresse",
            city: "Ville",
            postalCode: (0, export_1.getExportPostalCodeColumnLabel)(locales_1.Locales.FR, country),
            country: "Pays",
            region: (0, export_1.getExportRegionColumnLabel)(locales_1.Locales.FR, country),
            phoneNumber: "Téléphone",
            companyName: "Nom de l'entreprise",
            notes: "Notes",
            manualLists: "Listes manuelles",
            unsubscribe: "Désabonné",
        },
        [locales_1.Locales.EN]: {
            firstName: "First name",
            lastName: "Last name",
            email: "Email",
            secondaryEmail: "Secondary email",
            amount: "Amount",
            firstPaymentDate: `First payment date (${timezone})`,
            lastPaymentDate: `Last payment date (${timezone})`,
            locale: "Language",
            address: "Address",
            city: "City",
            postalCode: (0, export_1.getExportPostalCodeColumnLabel)(locales_1.Locales.EN, country),
            country: "Country",
            region: (0, export_1.getExportRegionColumnLabel)(locales_1.Locales.EN, country),
            phoneNumber: "Phone",
            companyName: "Company name",
            notes: "Notes",
            manualLists: "Manual lists",
            unsubscribe: "Unsubscribed",
        },
        [locales_1.Locales.ES]: {
            firstName: "Prénom",
            lastName: "Nom",
            email: "Courriel",
            secondaryEmail: "Courriel secondaire",
            amount: "Montant",
            firstPaymentDate: `Date du premier paiement (${timezone})`,
            lastPaymentDate: `Date du dernier paiement (${timezone})`,
            locale: "Langue",
            address: "Adresse",
            city: "Ville",
            postalCode: (0, export_1.getExportPostalCodeColumnLabel)(locales_1.Locales.ES, country),
            country: "Pays",
            region: (0, export_1.getExportRegionColumnLabel)(locales_1.Locales.ES, country),
            phoneNumber: "Téléphone",
            companyName: "Nom de l'entreprise",
            notes: "Notes",
            manualLists: "Listes manuelles",
            unsubscribe: "Désabonné",
        },
        [locales_1.Locales.DE]: {
            firstName: "Vorname",
            lastName: "Nachname",
            email: "E-Mail",
            secondaryEmail: "Zweite E-Mail",
            amount: "Betrag",
            firstPaymentDate: `Datum der ersten Zahlung (${timezone})`,
            lastPaymentDate: `Datum der letzten Zahlung (${timezone})`,
            locale: "Sprache",
            address: "Adresse",
            city: "Stadt",
            postalCode: (0, export_1.getExportPostalCodeColumnLabel)(locales_1.Locales.DE, country),
            country: "Land",
            region: (0, export_1.getExportRegionColumnLabel)(locales_1.Locales.DE, country),
            phoneNumber: "Telefon",
            companyName: "Unternehmensname",
            notes: "Notizen",
            manualLists: "Manuelle Listen",
            unsubscribe: "Abgemeldet",
        },
    };
};
exports.getExportSupportColumnLabels = getExportSupportColumnLabels;
exports.exportFundraiserColumnLabels = {
    [locales_1.Locales.FR]: {
        type: "Type",
        formName: "Nom du formulaire",
        firstName: "Prénom",
        lastName: "Nom",
        email: "Courriel",
        donationVolume: "Montant récolté",
        target: "Objectif",
        team: "Équipe",
    },
    [locales_1.Locales.EN]: {
        type: "Type",
        formName: "Form title",
        firstName: "First name",
        lastName: "Last name",
        email: "Email",
        donationVolume: "Collected amount",
        target: "Target",
        team: "Team",
    },
    [locales_1.Locales.ES]: {
        type: "Type",
        formName: "Form title",
        firstName: "First name",
        lastName: "Last name",
        email: "Email",
        donationVolume: "Collected amount",
        target: "Target",
        team: "Team",
    },
    [locales_1.Locales.DE]: {
        type: "Typ",
        formName: "Formulartitel",
        firstName: "Vorname",
        lastName: "Nachname",
        email: "E-Mail",
        donationVolume: "Gesammelter Betrag",
        target: "Ziel",
        team: "Team",
    },
};
exports.exportPayoutColumnLabels = {
    [locales_1.Locales.FR]: {
        id: "Id",
        amount: "Montant",
        createdAt: "Date de création",
        arrivalDate: "Date d'arrivée",
        statementDescriptor: "Libellés de relevé bancaire",
        status: "Status",
        accountHolderName: "Nom du titulaire du compte",
        account: "Compte",
    },
    [locales_1.Locales.EN]: {
        id: "Id",
        amount: "Amount",
        createdAt: "Creation date",
        arrivalDate: "Arrival date",
        statementDescriptor: "Statement descriptor",
        status: "Status",
        accountHolderName: "Account holder name",
        account: "Account",
    },
    [locales_1.Locales.ES]: {
        id: "Id",
        amount: "Amount",
        createdAt: "Creation date",
        arrivalDate: "Arrival date",
        statementDescriptor: "Statement descriptor",
        status: "Status",
        accountHolderName: "Account holder name",
        account: "Account",
    },
    [locales_1.Locales.DE]: {
        id: "Id",
        amount: "Betrag",
        createdAt: "Erstellungsdatum",
        arrivalDate: "Ankunftsdatum",
        statementDescriptor: "Kontoauszugsbeschreibung",
        status: "Status",
        accountHolderName: "Name des Kontoinhabers",
        account: "Konto",
    },
};
exports.exportProductBidsColumnLabels = {
    [locales_1.Locales.EN]: {
        date: "Date",
        amount: "Amount",
        email: "Contact email",
        firstName: "First name",
        lastName: "Last name",
        title: "Item",
        status: "Status",
    },
    [locales_1.Locales.FR]: {
        date: "Date",
        amount: "Montant",
        email: "Courriel du contact",
        firstName: "Prénom",
        lastName: "Nom",
        title: "Article",
        status: "Statut",
    },
    [locales_1.Locales.ES]: {
        date: "Fecha",
        amount: "Monto",
        email: "Correo electrónico de contacto",
        firstName: "Nombre",
        lastName: "Apellido",
        title: "Artículo",
        status: "Estado",
    },
    [locales_1.Locales.DE]: {
        date: "Datum",
        amount: "Betrag",
        email: "Kontakt-E-Mail",
        firstName: "Vorname",
        lastName: "Nachname",
        title: "Artikel",
        status: "Status",
    },
};
exports.exportBalanceTransactionColumnLabels = {
    [locales_1.Locales.FR]: {
        date: "Date",
        amount: "Montant",
        balance: "Solde",
        type: "Type",
        details: "Détails",
    },
    [locales_1.Locales.EN]: {
        date: "Date",
        amount: "Amount",
        balance: "Balance",
        type: "Type",
        details: "Details",
    },
    [locales_1.Locales.ES]: {
        date: "Date",
        amount: "Amount",
        balance: "Balance",
        type: "Type",
        details: "Details",
    },
    [locales_1.Locales.DE]: {
        date: "Datum",
        amount: "Betrag",
        balance: "Saldo",
        type: "Typ",
        details: "Details",
    },
};
exports.exportReceiptColumnLabels = {
    [locales_1.Locales.FR]: {
        name: "Nom",
        createdAt: "Date de création",
        amount: "Montant",
        eligibleAmount: "Montant éligible",
        fileUrl: "Lien",
        number: "Numéro",
        status: "Statut",
    },
    [locales_1.Locales.EN]: {
        name: "Name",
        createdAt: "Creation date",
        amount: "Amount",
        eligibleAmount: "Eligible amount",
        fileUrl: "Link",
        number: "Number",
        status: "Status",
    },
    [locales_1.Locales.ES]: {
        name: "Name",
        createdAt: "Creation date",
        amount: "Amount",
        eligibleAmount: "Eligible amount",
        fileUrl: "Link",
        number: "Number",
        status: "Status",
    },
    [locales_1.Locales.DE]: {
        name: "Name",
        createdAt: "Erstellungsdatum",
        amount: "Betrag",
        eligibleAmount: "Abzugsfähiger Betrag",
        fileUrl: "Link",
        number: "Nummer",
        status: "Status",
    },
};
const getExportDonorReportColumnLabels = (country) => ({
    [locales_1.Locales.EN]: {
        email: "Contact email",
        firstName: "First name",
        lastName: "Last name",
        address: "Address",
        postalCode: (0, export_1.getExportPostalCodeColumnLabel)(locales_1.Locales.EN, country),
        region: (0, export_1.getExportRegionColumnLabel)(locales_1.Locales.EN, country),
        city: "City",
        country: "Country",
        totalAmount: "Total amount",
        totalEligibleAmount: "Total eligible amount",
        date: "Date",
        amount: "Amount",
        eligibleAmount: "Eligible amount",
        paymentMethod: "Payment method",
        receiptUrl: "Receipt",
    },
    [locales_1.Locales.FR]: {
        email: "Contact email",
        firstName: "Prénom",
        lastName: "Nom",
        address: "Adresse",
        postalCode: (0, export_1.getExportPostalCodeColumnLabel)(locales_1.Locales.FR, country),
        region: (0, export_1.getExportRegionColumnLabel)(locales_1.Locales.FR, country),
        city: "Ville",
        country: "Pays",
        totalAmount: "Montant total",
        totalEligibleAmount: "Montant total éligible",
        date: "Date",
        amount: "Montant",
        eligibleAmount: "Montant éligible",
        paymentMethod: "Méthode de paiement",
        receiptUrl: "Reçu",
    },
    [locales_1.Locales.ES]: {
        email: "Contact email",
        firstName: "First name",
        lastName: "Last name",
        address: "Address",
        postalCode: (0, export_1.getExportPostalCodeColumnLabel)(locales_1.Locales.ES, country),
        region: (0, export_1.getExportRegionColumnLabel)(locales_1.Locales.ES, country),
        city: "Ciudad",
        country: "Country",
        totalAmount: "Total amount",
        totalEligibleAmount: "Total eligible amount",
        date: "Date",
        amount: "Amount",
        eligibleAmount: "Eligible amount",
        paymentMethod: "Payment method",
        receiptUrl: "Receipt",
    },
    [locales_1.Locales.DE]: {
        email: "Kontakt-E-Mail",
        firstName: "Vorname",
        lastName: "Nachname",
        address: "Adresse",
        postalCode: (0, export_1.getExportPostalCodeColumnLabel)(locales_1.Locales.DE, country),
        region: (0, export_1.getExportRegionColumnLabel)(locales_1.Locales.DE, country),
        city: "Stadt",
        country: "Land",
        totalAmount: "Gesamtbetrag",
        totalEligibleAmount: "Abzugsfähiger Gesamtbetrag",
        date: "Datum",
        amount: "Betrag",
        eligibleAmount: "Abzugsfähiger Betrag",
        paymentMethod: "Zahlungsmethode",
        receiptUrl: "Bestätigung",
    },
});
exports.getExportDonorReportColumnLabels = getExportDonorReportColumnLabels;
exports.exportYesNoLabels = {
    [locales_1.Locales.EN]: { yes: "Yes", no: "No" },
    [locales_1.Locales.FR]: { yes: "Oui", no: "Non" },
    [locales_1.Locales.ES]: { yes: "Oui", no: "Non" },
    [locales_1.Locales.DE]: { yes: "Ja", no: "Nein" },
};
exports.exportMembershipStatusLabels = {
    [locales_1.Locales.EN]: { active: "Active", expiringSoon: "Expiring soon", expired: "Expired" },
    [locales_1.Locales.FR]: { active: "Actif", expiringSoon: "Expire bientot", expired: "Expire" },
    [locales_1.Locales.ES]: { active: "Actif", expiringSoon: "Expire bientot", expired: "Expire" },
    [locales_1.Locales.DE]: { active: "Aktiv", expiringSoon: "Läuft bald ab", expired: "Abgelaufen" },
};
